// extracted by mini-css-extract-plugin
export default {"root":"_1fCCJ","animator":"_1FaMu","notification-link":"KVlv8","notificationLink":"KVlv8"};